import { useState } from 'react';
import Hero from './components/Hero';
import Menu from './components/Menu';
import About from './components/About';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import FloatingWhatsApp from './components/FloatingWhatsApp';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Menu />
      <About />
      <Gallery />
      <Contact />
      <FloatingWhatsApp />
    </div>
  );
}
